import type { Period } from 'types/global.types';
import { CURRENT_YEAR } from 'utils/constants';

const getPeriodSlug = (tax?: { period: Period }): string => {
  const { year, quarter, month } = tax?.period || {};
  if (month) {
    return `${year}-${month}`;
  } else if (quarter) {
    return `${year}-4${quarter}`;
  } else {
    return `${year || CURRENT_YEAR}`;
  }
};

export default getPeriodSlug;
